import { CommonModule } from '@angular/common';
import { Component, TemplateRef, ViewChild, } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModuleService } from '../../../Model/Module/module.service';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { RoleService } from '../../../Model/Role/role.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../../Util/Session/session.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-approval-matrix-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ApprovalMatrixFormFilterComponent, NgSelectModule, LoaderComponent],
  templateUrl: './approval-matrix-form.component.html',
  styleUrl: './approval-matrix-form.component.scss'
})
export class ApprovalMatrixFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  Modules = [] as any;
  Applicabilitys = [] as any;
  ApprovalCategorys = [] as any;
  ApprovalCategorysFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  ApplicabilityDatas = [
    // { ApplicabilityDataID: 1, ApplicabilityID: 1, ApplicabilityData: 'Company - 1', IsCheck: false }, { ApplicabilityDataID: 2, ApplicabilityID: 1, ApplicabilityData: 'Company - 2', IsCheck: false },
    // { ApplicabilityDataID: 3, ApplicabilityID: 2, ApplicabilityData: 'Branch - 1', IsCheck: false }, { ApplicabilityDataID: 4, ApplicabilityID: 2, ApplicabilityData: 'Branch - 2', IsCheck: false },
    // { ApplicabilityDataID: 5, ApplicabilityID: 3, ApplicabilityData: 'Client - 1', IsCheck: false }, { ApplicabilityDataID: 6, ApplicabilityID: 3, ApplicabilityData: 'Client - 2', IsCheck: false },
    // { ApplicabilityDataID: 7, ApplicabilityID: 4, ApplicabilityData: 'Site - 1', IsCheck: false }, { ApplicabilityDataID: 8, ApplicabilityID: 4, ApplicabilityData: 'Site - 2', IsCheck: false },
    // { ApplicabilityDataID: 9, ApplicabilityID: 5, ApplicabilityData: 'Department - 1', IsCheck: false }, { ApplicabilityDataID: 10, ApplicabilityID: 5, ApplicabilityData: 'Department - 2', IsCheck: false },
    // { ApplicabilityDataID: 11, ApplicabilityID: 6, ApplicabilityData: 'Designation - 1', IsCheck: false }, { ApplicabilityDataID: 12, ApplicabilityID: 6, ApplicabilityData: 'Designation - 2', IsCheck: false },
    // { ApplicabilityDataID: 13, ApplicabilityID: 7, ApplicabilityData: 'Employee - 1', IsCheck: false }, { ApplicabilityDataID: 24, ApplicabilityID: 7, ApplicabilityData: 'Employee - 2', IsCheck: false },
    // { ApplicabilityDataID: 14, ApplicabilityID: 1, ApplicabilityData: 'Company - 3', IsCheck: false }, { ApplicabilityDataID: 14, ApplicabilityID: 1, ApplicabilityData: 'Company - 4', IsCheck: false },

    // { ApplicabilityDataID: 15, ApplicabilityID: 1, ApplicabilityData: 'Company - 5', IsCheck: false }, { ApplicabilityDataID: 16, ApplicabilityID: 1, ApplicabilityData: 'Company - 6', IsCheck: false },
    // { ApplicabilityDataID: 17, ApplicabilityID: 1, ApplicabilityData: 'Company - 7', IsCheck: false }, { ApplicabilityDataID: 18, ApplicabilityID: 1, ApplicabilityData: 'Company - 8', IsCheck: false },
    // { ApplicabilityDataID: 19, ApplicabilityID: 1, ApplicabilityData: 'Company - 9', IsCheck: false }, { ApplicabilityDataID: 20, ApplicabilityID: 1, ApplicabilityData: 'Company - 10', IsCheck: false },
    // { ApplicabilityDataID: 21, ApplicabilityID: 1, ApplicabilityData: 'Company - 11', IsCheck: false }, { ApplicabilityDataID: 22, ApplicabilityID: 1, ApplicabilityData: 'Company - 12', IsCheck: false },
  ] as any;
  ApplicabilityDatasFilter = [] as any;

  Reporting = [{ ReportingID: 1, Value: 'Reporting - 1' }, { ReportingID: 2, Value: 'Reporting - 2' }];

  ApprovalMatrixDetail = {
    SelectType: 'I',
    WebESSApprovalMatrixId: 0,
    WebESSModuleMasterId: null,
    WorkFlowName: null,
    IsMaxAgeLimit: false,
    TravelType: 'Local',
    ESS_ApprovalMatrixDetails: [{
      ApprovalLevel: null,
      ApprovalCategoryId: null,
      ApprovalCategoryVal: null,
      TAT_INDays: null as any,
      ViewSubCategory: false,
      IsAutoRejection: false,
    }],
    EmpType: 'FRONT',
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
    IsAllowMaxAgeLimit: false,
    IsAllowTravelType: false,
  }

  constructor(
    private module: ModuleService,
    private combo: ComboService,
    private approvalMatrix: ApprovalMatrixService,
    private role: RoleService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService
  ) {
    this.common.CompanyParameter();
    this.common.getPageRights();
    this.route.params.subscribe(params => this.ApprovalMatrixDetail.WebESSApprovalMatrixId = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.GetModule();
    this.GetApprovalCategory();
    if (this.ApprovalMatrixDetail.WebESSApprovalMatrixId == 0) {
      this.GetApplicability();
    }
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.SaveApprovalMatrix();
    }
    else {
      form.submitted = true;
    }
  }

  GetModule() {
    this.isDisabled = true;
    this.module.GetModule({ SelectType: 'S', WebESSModuleMasterID: 0 }).subscribe({
      next: (response) => {
        this.Modules = response.Table;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApprovalCategory() {
    this.isDisabled = true;
    this.approvalMatrix.GetApprovalCategory({ SelectType: 'S', WebESSApprovalCategoryMasterID: 0 }).subscribe({
      next: (response) => {
        this.ApprovalCategorys = response.Table;
        this.ApprovalCategorysFilter = response.Table;
        this.isDisabled = false;
      },
      complete: () => {
        if (this.ApprovalMatrixDetail.WebESSApprovalMatrixId > 0) {
          this.GetApprovalMatrix();
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApprovalMatrix() {
    this.isDisabled = true;
    this.approvalMatrix.GetApprovalMatrix({ ApprovalMatrixId: this.ApprovalMatrixDetail.WebESSApprovalMatrixId, SelectType: 'S' }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          this.ApprovalMatrixDetail.EmpType = 'FRONT';
        } else {
          this.ApprovalMatrixDetail.EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.ApprovalMatrixDetail.SelectType = 'U';
        this.ApprovalMatrixDetail.WebESSApprovalMatrixId = response.Table[0].WebESSApprovalMatrixID;
        this.ApprovalMatrixDetail.WebESSModuleMasterId = response.Table[0].WebESSModuleMasterId;
        this.ApprovalMatrixDetail.WorkFlowName = response.Table[0].WorkFlowName;
        this.ApprovalMatrixDetail.WebESSApplicabilityId = response.Table[0].WebESSApplicabilityId;
        this.LastWebESSApplicabilityId = this.ApprovalMatrixDetail.WebESSApplicabilityId;
        this.ApprovalMatrixDetail.IsMaxAgeLimit = response.Table[0].IsMaxAgeLimit;
        this.ApprovalMatrixDetail.TravelType = response.Table[0].TravelType;
        this.ApprovalMatrixDetail.MappedId = response.Table1.map((e: any) => e.MappedId).toString();
        this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails = [];
        this.IsMaxEdgeAllow();
        this.IsAllowTravelType()
        response.Table2.forEach((element: any, index: number) => {
          this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.push({
            ApprovalLevel: element.ApprovalLevel,
            ApprovalCategoryId: element.WebESSApprovalCategoryMasterId,
            ApprovalCategoryVal: element.ApprovalCategoryVal,
            TAT_INDays: element.TAT_INDays,
            ViewSubCategory: element.ApprovalCategoryVal > 0 ? true : false,
            IsAutoRejection: element.IsAutoRejection
          });

          if (element.ApprovalCategoryVal > 0) {
            this.ApprovalTypeChange(index)
          }
        });

        if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table1.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table1.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 8) {
          // response.Table1.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table1.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalTypeChange(index: number,clear = false) {
    if(clear){
      this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ApprovalCategoryVal = null;
    }
    this.ApprovalSubCategory = [];

    this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ViewSubCategory = this.ApprovalCategorys.filter((e: any) => e.WebESSApprovalCategoryMasterID == this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ApprovalCategoryId)[0].IsSubMasterApplicable;

    if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ViewSubCategory) {
      //Reporting To
      if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ApprovalCategoryId == 6) {
        this.Reporting.forEach((element: any) => {
          this.ApprovalSubCategory.push(
            {
              ApprovalSubCategoryID: element.ReportingID,
              ApprovalSubCategory: element.Value,
            }
          );
        });
        this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
      }
      //Role 
      else if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ApprovalCategoryId == 7) {
        this.GetRole(index);
      }
      //User 
      else if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails[index].ApprovalCategoryId == 8) {
        this.ApprovalComboLoad('User', 'Employee', index);
      }
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                  IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;
          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                  IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          this.ApprovalSubCategory = [];
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });

          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                IsCheck: this.ApprovalMatrixDetail.MappedId != null ? this.ApprovalMatrixDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        if (Combotype2 != 'Employee') {
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
          this.ApprovalMatrixDetail.MappedId = null;
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetRole(index: number) {
    this.isDisabled = true;
    this.ApprovalSubCategory = [];
    this.role.GetRole({ SelectType: 'S', WebESSRoleMasterId: 0 }).subscribe({
      next: (response) => {
        response.Table.forEach((element: any) => {
          this.ApprovalSubCategory.push(
            {
              ApprovalSubCategoryID: element.WebESSRoleMasterID,
              ApprovalSubCategory: element.RoleName,
            }
          );
        });
        this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  // GetApplicability() {
  //   this.isDisabled = true;
  //   this.approvalMatrix.GetApplicability({ SelectType: 'S', WebESSApplicabilityMasterID: 0 }).subscribe({
  //     next: (response) => {
  //       this.Applicabilitys = response.Table;
  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.ApprovalMatrixDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.ApprovalMatrixDetail.WebESSApplicabilityId).length == 0) {
          this.ApprovalMatrixDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.ApprovalMatrixDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.ApprovalMatrixDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.ApprovalMatrixDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.ApprovalMatrixDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
    //return this.ApplicabilityDatas.filter(e => e.ApplicabilityID == this.ApprovalMatrixDetail.WebESSApplicabilityId);
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.ApprovalMatrixDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.ApprovalMatrixDetail.WebESSApplicabilityId == 3 ? 'Client' : this.ApprovalMatrixDetail.WebESSApplicabilityId == 4 ? 'Site' : this.ApprovalMatrixDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.ApprovalMatrixDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.ApprovalMatrixDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.ApprovalMatrixDetail.WebESSApplicabilityId == 3 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 4 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.ApprovalMatrixDetail.WebESSApplicabilityId == 4 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.ApprovalMatrixDetail.WebESSApplicabilityId == 8 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            console.log(element);
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              console.log("In");
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site')
        }
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          console.log('all modal result Data ', result);
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  AddApproval() {
    this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.push({
      ApprovalLevel: null,
      ApprovalCategoryId: null,
      ApprovalCategoryVal: null,
      TAT_INDays: null,
      ViewSubCategory: false,
      IsAutoRejection: false
    });
  }

  DeleteApproval(Index: number) {
    this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.splice(Index, 1);
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.ApprovalMatrixDetail.WebESSApplicabilityId == 3 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 4 || this.ApprovalMatrixDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  async SaveApprovalMatrix() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.length == 0) {
      this.toast.show({ message: 'Add atleast one approval', type: toastTypeEnum.warning });
    } else if (this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.filter(e => e.TAT_INDays > 365).length) {
      this.toast.show({ message: 'TAT maximum 365', type: toastTypeEnum.warning });
    } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
    } else if (this.ApprovalMatrixDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
    } else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.ApprovalMatrixDetail.WebESSApprovalMatrixId == 0) || (this.common.PageRight.IsEdit && this.ApprovalMatrixDetail.WebESSApprovalMatrixId > 0)) {
          if (result) {
            this.isDisabled = true;
            this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.forEach((element: any, index) => {
              element.ApprovalLevel = index + 1;
            });
            this.ApprovalMatrixDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).map((e: any) => e.ApplicabilityDataID).toString();
            this.approvalMatrix.SaveApprovalMatrix(this.ApprovalMatrixDetail).subscribe({
              next: (response) => {
                if (response.Error_Code == '195' || response.Error_Code == '196') {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }, reason => { });
    }
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  DefaultTATSet() {
    this.ApprovalMatrixDetail.ESS_ApprovalMatrixDetails.map(e => e.TAT_INDays = this.Modules.filter((e: any) => e.WebESSModuleMasterID == this.ApprovalMatrixDetail.WebESSModuleMasterId)[0].DefaultTAT_InDays);
    this.IsMaxEdgeAllow();
    this.IsAllowTravelType();
  }

  ComboLoad(Combotype: String, id: number) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'EmpMasterID': id, 'EmpType': this.ApprovalMatrixDetail.EmpType, }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.ApprovalMatrixDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }

        }
        this.isDisabled = false;
      },
      complete: () => {

      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  IsMaxEdgeAllow() {
    if (this.ApprovalMatrixDetail.WebESSModuleMasterId != 1 && this.ApprovalMatrixDetail.WebESSModuleMasterId != 2) {
      this.ApprovalMatrixDetail.IsMaxAgeLimit = false;
      this.Filter.IsAllowMaxAgeLimit = false;
    } else {
      if (this.common.CompanyParameterValue.MaxAgeAllowed > 0) {
        this.Filter.IsAllowMaxAgeLimit = true;
      } else {
        this.Filter.IsAllowMaxAgeLimit = false;
      }
    }
  }

  IsAllowTravelType() {
    if (this.ApprovalMatrixDetail.WebESSModuleMasterId == 8) {
      this.Filter.IsAllowTravelType = true;
    } else {
      this.Filter.IsAllowTravelType = false;
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  close() {
    this.router.navigate(['/setting/approvalmatrix/']);
  }
}
